import { getAxiosClient } from "waapi/palpatine-client/getAxiosClient.js";
import type { ClientGeneratorProps } from "waapi/front-utils/hooks/useApiClients/types.js";
import { palpatineLifelineMethodsMap, palpatineMethodsMap } from "./palpatineMethodsMap.js";
import type { PalpatineClient } from "./types.js";

export const createPalpatineClient = ({ apiUrl, apiToken }: ClientGeneratorProps): PalpatineClient => {
    return {
        ...palpatineMethodsMap(getAxiosClient({ baseUrl: apiUrl, headers: { ...(apiToken ? { Authorization: `Bearer ${apiToken}` } : {}) } })),
        ...palpatineLifelineMethodsMap(getAxiosClient({ baseUrl: apiUrl, headers: {} })),
    };
};
